import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}

// ng2-pdf-viewer: servir el worker de pdf.js localmente (evita CDN externo / bloqueo por CSP)
(window as any).pdfWorkerSrc = 'assets/pdf.worker.min.js';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
